import { useEnrollOrganizationMutation } from "@api/billingOrganization.api";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useEffect } from "react";
import { StringParam, useQueryParams, withDefault } from "use-query-params";

export const EnrollReturn: React.FC = () => {
    const activeOrganization = useActiveOrganization();
    const navigate = useStateAwareNavigate();
    const [params] = useQueryParams({
        after: StringParam,
        setup_intent: withDefault(StringParam, undefined),
    });

    const enrollMutation = useEnrollOrganizationMutation(
        activeOrganization?.id ?? "",
    );

    useEffect(() => {
        if (
            !activeOrganization ||
            !enrollMutation.isIdle ||
            !params.setup_intent
        ) {
            return;
        }

        enrollMutation.mutate(params.setup_intent, {
            onSuccess: () => {
                navigate(params.after ?? "/");
            },
        });
    }, [activeOrganization, enrollMutation, params, navigate]);

    return <PageCoverLoader>Saving payment details</PageCoverLoader>;
};
